import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { IRootState } from '@/redux/reducers'
import IntroModalContent from './IntroModalContent'
import ModalWrapper from '../modals/ModalWrapper'
import YourWorkspacesModal from './YourWorkspacesModal'
import LearningTracksAction from '../../redux/actions/learningTracks/LearningTracksAction'
import { openInNewTab } from '@/helpers/http'


const IntroModal = () => {
    const dispatch = useDispatch()
    const showModal = useSelector((state: IRootState)  => state.learningTracks.showIntroModal)
    const [showWorkSpaces, setShowWorkSpaces] = useState(false)
           
    useEffect(() => {
        dispatch(LearningTracksAction.requestLearningTracks())
    }, [])

    const onCloseModal = () => {
        dispatch(LearningTracksAction.setIntroModalStatus(false))
    }

    // prevent scroll when modal is open
    useEffect(() =>  {
        if (showModal) {document.body.style.overflowY = "hidden"}
        else {document.body.style.overflowY = "initial"}

        return () => {document.body.style.overflowY = "initial"}
    }, [showModal])

    function onOpenHelpCentreClick() {
        onCloseModal();

        openInNewTab('https://thrive.app/help-centre/');
    }

    let Content = () => {    
        if (showWorkSpaces){
            return <YourWorkspacesModal onClose={onCloseModal} showWelcome={true} />
        }

        return <IntroModalContent showWorkspaces={() => setShowWorkSpaces(true)} openHelpCentre={onOpenHelpCentreClick} />
    }

    return (
        <ModalWrapper isOpen={showModal} escClose={false} onRequestClose={onCloseModal} className='intro-modal'>           
           <Content />
        </ModalWrapper>
    );
};

export default IntroModal;